// lib
import React from 'react'
import PropTypes from 'prop-types'

// components
import SpecificationsPanelSurvey from '@aytm/app/stats/page/sidebar/specifications/components/SpecificationsPanelSurvey'
import SpecificationsListSurvey from '@aytm/app/stats/page/sidebar/specifications/components/SpecificationsListSurvey'

// styles
import style from '@aytm/app/stats/page/sidebar/specifications/styles/SpecificationsPanel.module.scss'

const SpecificationsPanel = ({ root, model, isExternalSurvey }) => (
  <div className={style.component}>
    <div className={style['component-title']}>Survey Specifications</div>

    <div className={style.section}>
      <div className={`${style.row} ${style['section-title']}`}>Order details:</div>

      <div className={style.row}>
        <span className={`${style.column} ${style['column-label']}`}>Responses:</span>
        <div className={`${style.column} ${style['column-values']}`}>
          {model.totalRespondents}/{model.respondents}
          <span> fulfilled</span>
        </div>
      </div>
      {model.video_respondents ? (
        <div className={style.row}>
          <span className={`${style.column} ${style['column-label']}`}>Video clips:</span>
          <div className={`${style.column} ${style['column-values']}`}>
            {model.totalVideoResponses}/{model.video_respondents}
            <span> fulfilled</span>
          </div>
        </div>
      ) : null}
      <div className={style.row}>
        <span className={`${style.column} ${style['column-label']}`}>Ordered:</span>
        <div className={`${style.column} ${style['column-values']}`}>{model.survey_started_at || 'N/A'}</div>
      </div>
      <div className={style.row}>
        <span className={`${style.column} ${style['column-label']}`}>Completed:</span>
        <div className={`${style.column} ${style['column-values']}`}>
          {model.survey_finished_at ||
            (model.survey_started_at && 'in progress') ||
            (model.has_fake_responses && 'artificial responses') ||
            'N/A'}
        </div>
      </div>
      <div className={style.row}>
        <span className={`${style.column} ${style['column-label']}`}>Type:</span>
        <div className={`${style.column} ${style['column-values']}`}>{model.research_type || 'None'}</div>
      </div>
    </div>

    {0 < model.tags.length ? (
      <div className={style.section}>
        <div className={`${style.row} ${style['section-title']}`}>Prequals:</div>

        {model.tags
          .filter(tag => null !== tag.name && 0 < tag.name.length)
          .map(tag => (
            <div key={tag.name} className={style.row}>
              <div className={style.column}>
                {tag.custom ? (
                  'Custom question'
                ) : (
                  <>
                    {tag.name} {tag.positive ? 'only' : 'excluded'}
                  </>
                )}
              </div>
            </div>
          ))}
      </div>
    ) : null}

    {isExternalSurvey ? (
      <SpecificationsListSurvey model={model} />
    ) : (
      <SpecificationsPanelSurvey root={root} model={model} />
    )}

    <div className={style.section}>
      <div className={style.row}>
        <span className={`${style.column} ${style['column-label']}`}>See how survey takers saw this survey</span>
        <div className={`${style.column} ${style['column-values']}`}>
          <a className={style.preview} href={model.survey_preview_path} target="_blank" rel="noreferrer">
            <i className="icon-aytmfd-preview" />
          </a>
        </div>
      </div>
    </div>
  </div>
)

SpecificationsPanel.propTypes = {
  root: PropTypes.any,
  model: PropTypes.object,
  isExternalSurvey: PropTypes.bool
}

SpecificationsPanel.displayName = 'SpecificationsPanel'

export default SpecificationsPanel
